// extracted by mini-css-extract-plugin
module.exports = {"Login":"_1oNo7ULVfdYEQzsmQL5G8g"};